const contribute = [{"key":"contribute.greeting","string":"Dobrý deň {variable}, tu je prehľad Vášho obsahu."},{"key":"contribute.logout","string":"Odhlásiť"}]

export default contribute



// WEBPACK FOOTER //
// ./src/i18n/sk/contribute/_contribute.js